/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { styled, useFlux } from 'fierry/react.old';

import BorderCenter from 'galax/react/map/hex/border.center';


const TransferPath = styled.path`
  fill: var(--svg-always-white);
  stroke: var(--svg-always-black);

  stroke-width: 1.5px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;


const getTransferPath = ({ geometry }) =>
{
  return `M 0,1.5 l -3,-1.5 l 3,-1.5 m -3 1.5 l 6 0`;
}


const Indicator = (props) =>
{
  return <TransferPath {...props} d = {getTransferPath(props)} />;
}


const Component = ({ borders, ...props }) =>
{
  let children = [];

  for (const index of borders)
  {
    children.push(<BorderCenter {...props} key = {index} Component = {Indicator} index = {index} />);
  }

  return children;
}


export default (props) =>
{
  const { zone, geometry, isTarget } = props;

  if (isTarget || !geometry.getHex().isEntityVisible())
  {
    return null;
  }

  const borders = zone.getSector().getTransfers().getTransferBorders(zone);

  if (borders.length)
  {
    return <Component {...props} borders = {borders} />
  }

  return null;
}
